import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {AppConstants} from '../constant/app.constants';

@Injectable()
export class FileUploadService {
    _url: string;
    headers: any;

    constructor(private http: HttpClient) {
    }

    uploadImage(data: any): Observable<{}> {
        this._url = AppConstants.SITE_URL + 'upload/uploadImages';
        return this.http.post(this._url, data)
            .map(this.handleData)
            .catch(this.handleError);
    }

    uploadFile(data: any): Observable<{}> {
        this._url = AppConstants.SITE_URL + 'upload/uploadFile';
        return this.http.post(this._url, data)
            .map(this.handleData)
            .catch(this.handleError);
    }

    downloadImage(imageUrl: string) {
        return this.http.get(imageUrl, {observe: 'response', responseType: 'blob'})
            .map((res) => {
                return new Blob([res.body], {type: res.headers.get('Content-Type')});
            });
    }

    private handleData(res: Response) {
        return res;
    }

    private handleError(error: Response | any) {
        return Observable.throw('API failed');
    }
}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/file_upload.service.ts